import { getShellLogger } from '../../common/logger'
import { isI18nLocale } from '../../common/translate-helpers/locales'
import { environment } from '../../environments'
import { wrappedAuthenticatedFetch } from '../auth/wrapper'
import type { UserProfileInfo } from './models'

export const getEmailsFromUserProfile = (me?: UserProfileInfo) => me?.emails ?? []

export const getEntitlementsFromUserProfile = (me?: UserProfileInfo) => me?.entitlements ?? []

export const getIdFromUserProfile = (me?: UserProfileInfo) => me?.id

export const getLocaleFromUserProfile = (me?: UserProfileInfo) => me?.locale

export const getUserNameFromUserProfile = (me?: UserProfileInfo) => me?.userName

export const updateUserProfileLocale = async (value: unknown) => {
  if (!isI18nLocale(value)) {
    throw new TypeError(`Unsupported locale ${value}`)
  }

  try {
    await wrappedAuthenticatedFetch<UserProfileInfo>(`${environment().iamBaseUrl}/identity/v1/Users/me`, {
      credentials: undefined,
      method: 'PATCH',
      body: JSON.stringify({ locale: value }),
      headers: [['Content-Type', 'application/json']],
    })
  } catch (err) {
    const msg = `Unable to update user profile's locale with value: '${value}'.`
    getShellLogger().error(msg)
    throw new Error(msg)
  }
}

export const createUserProfileInfo = (userProfileInfo: UserProfileInfo): UserProfileInfo => ({
  ...userProfileInfo,
  emails: userProfileInfo.emails ?? [],
  entitlements: userProfileInfo.entitlements ?? [],
})
